import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { DateFormatService, RichsnipetService } from 'dmmp-services'
import { RemoveHtmlPipe } from '../../../pipes/removeHtml.pipe'

@Component({
  selector: 'dmmp-video-gallery',
  templateUrl: './video-gallery.component.html',
})
export class VideoGalleryComponent implements OnInit {
  @Input() defaultClass
  @Input() image
  @Input() videoSrc = null
  @Input() videoType = null
  @Input() categories
  @Input() medias
  @Input() title
  @Input() date
  @Input() path
  @Input() description
  @Output() page = new EventEmitter()
  schemaItemVideo = []

  constructor(private dateFormat: DateFormatService, private richsnipetService: RichsnipetService, private removeHtmlPipe: RemoveHtmlPipe) {
  }

  ngOnInit() {
    this.date = this.dateFormat.convertFromTimestampToDate(this.date)
    this.selectCategories(this.categories.identifier)
    if (this.videoSrc) {
      this.schemaItemVideo = this.richsnipetService.setupJsonVideo(
        this.title ? this.removeHtmlPipe.transform(this.title) : '',
        this.description ? this.removeHtmlPipe.transform(this.description) : '',
        this.image && this.image.length > 0 && this.image.styles.large ? this.image.styles.large : '',
        this.date ? this.date : '',
        this.videoSrc ? this.videoSrc : '')

    }
  }

  selectCategories(identifier) {
    switch (identifier) {
      case 'news':
        this.categories = this.categories.topics && this.categories.topics.length > 0 ? this.categories.topics[0] : null
        break
      case 'blog':
        this.categories = this.categories.categories && this.categories.categories.length > 0 ? this.categories.categories[0] : null
        break
      case 'event':
        this.categories = this.categories.type && this.categories.type.length > 0 ? this.categories.type[0].label : null
        break
      default:
        break
    }
  }
}
